import type { Slide } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { BaseSceneSwapBridge } from 'js/src/libs/scene-swapping/BaseBridge';

export class OrdinaryToCommonBridge extends BaseSceneSwapBridge {
    override _from = VideoData.CATEGORY_ORDINARY;
    override _to = VideoData.CATEGORY_COMMON;

    override _isSwapAllowedFor(originalScene: Slide): boolean {
        // you can swap a ordinary scene to a common scene any time
        return true;
    }
}
